"use client"

import { useEffect } from "react"

/** Prevents pinch-zoom gestures when running as an installed PWA. */
export function NoPinchZoom() {
  useEffect(() => {
    if (!window.matchMedia("(display-mode: standalone)").matches) return

    const prevent = (e: TouchEvent) => {
      if (e.touches.length > 1) e.preventDefault()
    }

    document.addEventListener("touchmove", prevent, { passive: false })
    return () => document.removeEventListener("touchmove", prevent)
  }, [])

  return null
}
